import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, requireStaff, requireAdmin, requireSuperuser, requireBranchOnly, requireScope, requireAnyScope }) => {
  const { isAuthenticated, loading, isStaff, isAdmin, isSuperuser, hasScope } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requireSuperuser && !isSuperuser()) {
    return <Navigate to="/" />;
  }

  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/" />;
  }

  if (requireStaff && !isStaff()) {
    return <Navigate to="/" />;
  }

  // Restrict admin/superuser access to branch-only routes
  if (requireBranchOnly && (isSuperuser() || isAdmin() || isStaff())) {
    return <Navigate to="/" />;
  }

  if (requireScope && !hasScope(requireScope)) {
    return <Navigate to="/" />;
  }

  if (requireAnyScope && !requireAnyScope.some(s => hasScope(s))) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
